/* eslint-disable prefer-arrow-callback */
/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { applyDefaultClass, addUtils } from './class-name-helpers';

function PageWrapper({ className, tallNav, ...props }) {
  const { restProps, utilClassNames } = addUtils(props);
  const variants = { 'ss_page-wrapper--tall-nav': tallNav };
  const defaultClassName = applyDefaultClass(variants, 'ss_page-wrapper');

  return (
    <div
      className={clsx(
        className,
        defaultClassName,
        variants,
        utilClassNames,
      )}
      {...restProps}
    />
  );
}

PageWrapper.propTypes = {
  className: PropTypes.string,
  tallNav: PropTypes.bool,
  children: PropTypes.node.isRequired,
  bgDark: PropTypes.bool,
};
PageWrapper.defaultProps = {
  className: '',
  tallNav: false,
  bgDark: false,
};

export default PageWrapper;
